/**
 * "This browser has been signed in before."
 *
 * A per-viewer comfort, and nothing else. It exists so that the wait while the
 * session is verified can be drawn as the application loading instead of as the
 * sign-in gate: reloading a page you are already inside should not blink back
 * to a door.
 *
 * It is NEVER a permission. It lives in `localStorage`, which the person can
 * edit, and it unlocks nothing: every screen behind it still depends on a
 * session the server validated, and an unauthenticated answer still lands on
 * the gate. Authorization is enforced in FastAPI; React only decides what to
 * paint while waiting.
 */

const CLAVE = "sv.sesion.conocida";

/** Records the answer the server gave. Called for both answers, on purpose:
 *  without the clearing branch, a signed-out browser would keep waiting on an
 *  application frame for a session it no longer has. */
export function recordarSesion(conocida: boolean): void {
  try {
    if (conocida) localStorage.setItem(CLAVE, "1");
    else localStorage.removeItem(CLAVE);
  } catch {
    /* Private window or blocked storage: the comfort is lost, nothing else. */
  }
}

export function sesionConocida(): boolean {
  try {
    return localStorage.getItem(CLAVE) === "1";
  } catch {
    return false;
  }
}
